const env = process.env.NODE_ENV || "development";

const isProduction = env !== "development";

export const config = {
  API_URL: "https://rotest.heimat24.de/apps/rosenheim-main/api/",
};

export default config;
